var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectorSnapshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3818 30.8755C24.5902 31.3115 24.4065 31.8367 23.9581 32.0166C22.344 32.6643 20.6183 32.9982 18.8738 32.9972C16.8372 32.9961 14.8267 32.5386 12.9901 31.6584C11.1534 30.7782 9.5374 29.4976 8.26071 27.9108C6.98402 26.3239 6.07913 24.4712 5.61254 22.4887C5.14595 20.5062 5.12953 18.4444 5.56447 16.4547C5.99941 14.465 6.87467 12.5981 8.12592 10.9912C9.37716 9.38418 10.9726 8.07802 12.795 7.16865C14.3559 6.38972 16.0494 5.91887 17.7828 5.77872C18.2645 5.73977 18.6631 6.12793 18.6711 6.61111L18.8783 19.1751C18.8804 19.3007 18.9095 19.4245 18.9637 19.5379L24.3818 30.8755Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4586 16.7191C32.927 16.6005 33.4059 16.8838 33.4942 17.3589C34.0146 20.1578 33.6465 23.0577 32.4296 25.6475C31.2127 28.2372 29.2151 30.3715 26.7284 31.7573C26.3063 31.9925 25.7826 31.8047 25.5749 31.3684L20.5506 20.8128C20.3134 20.3146 20.591 19.7239 21.1259 19.5885L32.4586 16.7191Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6412 6.12671C19.6333 5.64353 20.0189 5.24248 20.5016 5.26556C23.2863 5.39874 25.9711 6.38343 28.1878 8.09717C30.4044 9.8109 32.0334 12.1613 32.8634 14.8228C33.0073 15.2841 32.7162 15.7583 32.2466 15.8723L20.9135 18.6233C20.3685 18.7556 19.8414 18.3481 19.8323 17.7873L19.6412 6.12671Z",
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorSnapshot);
export default __webpack_public_path__ + "static/media/sectorSnapshot.8713cacaf6230dea7954583debdc57bf.svg";
export { ForwardRef as ReactComponent };